import TableFilter from './tableFilter'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import ExportButton from '../../common/ExportButton'
import { appAllGetSocialProjectBooking } from '../../store/socialprojectbooking'
import { socialProjectBookingExportColumns } from '../../config/exportColumns/socialProjectBookingExportColumns'

function SocialProjectBooking() {
	const dispatch = useDispatch()

	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')

	const [exportFilters, setExportFilters] = useState({})

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading d-flex justify-content-between">
					<div>Social Project Donation</div>

					<ExportButton
						fetchAction={params =>
							dispatch(
								appAllGetSocialProjectBooking({
									...params,
									...exportFilters,
									hub: hubId || permissionOfHub,
									page: 1,
									limit: 10000,
									loading: false,
								}),
							)
						}
						columns={socialProjectBookingExportColumns}
						fileName="Social_Project_Donations"
						sheetName="Social Project Donations"
						buttonText="Export Donations"
					/>
				</div>

				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default SocialProjectBooking
